function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "#5B6572",
  fillRule: "nonzero",
  stroke: "#5B6572",
  strokeWidth: .2
}, React.createElement("path", {
  d: "M15.489 9.595l-4.362-2.716a.406.406 0 0 0-.404-.012.388.388 0 0 0-.206.34v5.43c0 .143.08.273.206.341a.404.404 0 0 0 .404-.013l4.362-2.715a.387.387 0 0 0 .183-.328.387.387 0 0 0-.183-.327zm-4.179 2.337V7.913l3.227 2.01-3.227 2.009z"
}), React.createElement("path", {
  d: "M23.603 1H1.397A.392.392 0 0 0 1 1.388v17.069c0 .214.178.388.397.388h22.206a.392.392 0 0 0 .397-.388V1.388A.392.392 0 0 0 23.603 1zM4.966 9.534H1.793v-3.49h3.173v3.49zm-3.173.776h3.173v3.492H1.793V10.31zm3.966 3.88V1.775H19.24V18.07H5.76v-3.88zm17.448-4.656h-3.173v-3.49h3.173v3.49zm-3.173.776h3.173v3.492h-3.173V10.31zm3.173-8.534v3.491h-3.173V1.776h3.173zm-21.414 0h3.173v3.491H1.793V1.776zm0 16.293v-3.491h3.173v3.491H1.793zm21.414 0h-3.173v-3.491h3.173v3.491z"
}));

const SvgComponent = props => React.createElement("svg", _extends({
  width: 25,
  height: 19,
  viewBox: "0 0 25 19"
}, props), _ref);

export default __webpack_public_path__ + "static/media/video-post-filter.94a6a910.svg";
export { SvgComponent as ReactComponent };